import { useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";
import { api } from "../api";
import { t } from "../i18n";
import { navigate } from "../utils/navigate";

export default function DoctorBoard({ lang }) {
  const { token } = useAuth();
  const [data, setData] = useState(null);
  const [err, setErr] = useState("");

  useEffect(() => {
    let live = true;
    api("/api/board", { token })
      .then((d) => live && setData(d))
      .catch((e) => live && setErr(e.message));
    return () => {
      live = false;
    };
  }, [token]);

  if (!data && !err) return <p className="tt-page">{t(lang, "loading")}</p>;

  return (
    <div className="tt-page">
      <div className="tt-row">
        <h2>{t(lang, "board")}</h2>
        <button className="tt-btn small" onClick={() => navigate("/write")}>
          {t(lang, "writeRx")}
        </button>
      </div>
      <p className="tt-muted">{data?.line || t(lang, "yourPanel")}</p>
      {err && <p className="tt-err">{err}</p>}

      <div className="tt-table-wrap">
        <table className="tt-table">
          <thead>
            <tr>
              <th>{t(lang, "whoReported")}</th>
              <th>{t(lang, "salt")}</th>
              <th></th>
              <th>{t(lang, "howSevere")}</th>
              <th>{t(lang, "whetherExpected")}</th>
            </tr>
          </thead>
          <tbody>
            {(data?.alerts || []).map((a) => (
              <tr
                key={a.id}
                className={a.is_unexpected || a.this_is_bad ? "hot" : ""}
                onClick={() => navigate(`/rx/${a.prescription_id}`)}
              >
                <td>{a.patient_name}</td>
                <td>
                  {a.salt} {a.strength}
                </td>
                <td>{a.effect}</td>
                <td>{t(lang, a.severity === "emergency" ? "emergency" : a.severity === "call_doctor" ? "callDoctor" : "mild")}</td>
                <td>
                  {a.is_unexpected ? (
                    <span className="tt-chip red">{t(lang, "unexpected")}</span>
                  ) : (
                    <span className="tt-chip">{t(lang, "expected")}</span>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {!(data?.alerts || []).length && <p className="tt-muted">{t(lang, "emptyBoard")}</p>}
      </div>

      <h3>{t(lang, "myMedicines")}</h3>
      <div className="tt-list">
        {(data?.patients || []).map((p) => (
          <div key={p.id} className="tt-rx">
            <strong>{p.name || p.phone}</strong>
            <span>{p.phone}</span>
            <span className="tt-muted">
              {p.active_rx} · {t(lang, "unexpected")} {p.unexpected_count || 0}
            </span>
          </div>
        ))}
      </div>
      <p className="tt-foot">{data?.copy?.never_stop || t(lang, "neverStop")}</p>
    </div>
  );
}
